import React, { CSSProperties } from 'react';

import { cn } from '../../../lib/css/className/className';
import { Tick } from '../Tick/Tick';
import { TestProps } from '../../../internal/types/testTypes';
import './Box.css';
import { CheckboxSize } from '../types';

const cnBox = cn('CheckboxBaseBox');

export interface BoxProps extends TestProps {
    size: CheckboxSize;
    isChecked?: boolean;
    isIndeterminate?: boolean;
    isFocused?: boolean;
    className?: string;
    tickClassName?: string;
    style?: CSSProperties;
}

export const Box = function Box(props: BoxProps) {
    const { size, isChecked, isIndeterminate, isFocused, className, tickClassName, style } = props;
    return (
        <div
            className={cnBox(
                {
                    size,
                    focused: isFocused,
                },
                [className],
            )}
            style={style}
            data-testid={props['data-testid']}
            data-checked={Boolean(isChecked)}
        >
            {(isChecked || isIndeterminate) && (
                <Tick size={size} isIndeterminate={isIndeterminate} className={tickClassName} />
            )}
        </div>
    );
};
